import { GTM_PARAMS } from './constants'

export const sendEventToGTM = (
  entity,
  type,
  filters
) => {
  const params = GTM_PARAMS[entity]

  window.dataLayer.push(serializeData(params, type, filters))
}

const serializeData = (params, type, filters) => {
  const { internalType, category, action, label } = params[type]
  const { dim1, dim2, dim3, dim4, dim5, dim6, dim7, dim8, dim9, dim10 } = params.filters

  const data = {
    'internal_type': internalType,
    'dimensions': {
      'category': category,
      'action': action,
      'label': label,
      'dim1': filters[dim1] || '',
      'dim2': filters[dim2] || '',
      'dim3': filters[dim3] || '',
      'dim4': filters[dim4] || '',
      'dim5': filters[dim5] || '',
      'dim6': filters[dim6] || '',
      'dim7': filters[dim7] || '',
      'dim8': filters[dim8] || '',
      'dim9': filters[dim9] || '',
      'dim10': filters[dim10] || ''
    }
  }

  if (type !== 'pageView') data['event'] = 'customEvent'
  return data
}